let cometd = require('./lib/cometd.js');

import { server, cometd_server } from '@/config';

let Video = require('./scooper.video');

let $ = require('jquery');
/**
 * 接口请求通用方法
 * @param {*} url 
 * @param {*} param 
 * @param {*} backSuccfn 
 * @param {*} async 
 * @param {*} method 
 */


export const loadJson = function (url, param, backSuccfn, async, method, headers, contentType) {
  method = method ? method : 'POST';
  async = async == undefined || async == '' ? true : async;

  for (let key in param) {
    //检测手机号码， 外地号码头部（非杭州）加00，本地号码加0
    if (/_phone01$/.test(key)) {
      let tel = key.replace(/_phone01$/, "");

      if (param[key] == 0) {
        //外地号码
        param[tel] = "00" + param[tel];
      } else {
        param[tel] = "0" + param[tel];
      }

      delete param[key];
    }
  }

  let ajaxContent = {
    'type': method,
    'url': url,
    'data': param,
    'timeout': 20000,
    'async': async
  };
  if (!headers) headers = {
    headers: {}
  };

  if (headers) {
    if (param.token) Object.assign(headers.headers, {
      'Sc-Token': param.token
    });
    Object.assign(ajaxContent, headers);
  }

  if (contentType) Object.assign(ajaxContent, {
    contentType
  });

  if (contentType && contentType.indexOf('application/json') != -1) {
    Object.assign(ajaxContent, {
      data: JSON.stringify(param)
    });
  }

  $.ajax(ajaxContent).fail(function (jqXHR, sts) {
    console.error('加载数据失败：' + sts + ", " + url);
    if (backSuccfn) backSuccfn(null);
    throw new Error('请求失败！');
  }).done(function (ret) {
    if (backSuccfn) backSuccfn(ret);

    if (!ret || ret.code != 0) {
      console.error('加载数据失败：' + JSON.stringify(ret) + ", " + url);
      throw new Error('加载数据失败！');
    }
  });
};
/**
 * @param {*} sip  //用户传过来的服务ip地址 http://{ip}:{port}
 * @param {*} meetcallfunc  会议通知处理
 * @param {*} callfunc   呼叫通知处理
 * @param {*} videocallfunc 视频通知处理
 * @param {*} connectcallfunc 通讯录通知处理
 */

export const initCometd = function (meetcallfunc, callfunc, videocallfunc, connectcallfunc, appMsgfunc, devicefunc, sip) {
  //初始
  let server_ = sip || server;

  let _cometd = new cometd.CometD("xjInfoReport");

  _cometd.websocketEnabled = true;
  let cometdUrl = server_ + cometd_server;

  _cometd.init({
    url: cometdUrl,
    logLevel: "info"
  });

  _cometd.addListener("/meta/handshake", function (message) {
    if (message.successful) {
      console.log("handshake success.");
    }
  });

  let _connected = false;

  _cometd.addListener('/meta/connect', function (message) {
    if (message.successful) {
      if (!_connected) {
        doSubscribe(_cometd, {
          meetcallfunc,
          callfunc,
          videocallfunc,
          connectcallfunc,
          appMsgfunc,
          devicefunc
        });
      }

      _connected = true;
    } else {
      _connected = false;
      console.log("连接cometd后台失败");
    }
  });
};

function doSubscribe(_cometd, callback) {
  /**
   * 会场模块消息通知
   */
  if (callback.meetcallfunc) {
    _cometd.subscribe("/dispatch-web/notify/meet/#", null, function (message) {
      callback.meetcallfunc(message);
    });
  }
  /**
   * 呼叫模块消息通知
   */


  if (callback.callfunc) {
    _cometd.subscribe("/dispatch-web/notify/call/#", null, function (message) {
      callback.callfunc(message);
    });
  }
  /**
   * 设备在离线状态消息通知
   */


  if (callback.devicefunc) {
    _cometd.subscribe("/device/res-status/#", null, function (message) {
      callback.devicefunc(message);
    });
  }
  /**
   * 视频通话状态消息通知(视频通话建立 和 中断)
   */


  if (callback.videocallfunc) {
    _cometd.subscribe("/server/#", null, function (message) {
      callback.videocallfunc(message);
    });
  } //'#'：多级通配，订阅所有的主题


  if (callback.connectcallfunc) {
    _cometd.subscribe("/scooper_core/#", null, function (message) {
      callback.connectcallfunc(message);
    });
  } // scooper-msg-app 人员状态变化通知


  if (callback.appMsgfunc) {
    _cometd.subscribe("/scooper-app-msg/orgmember/heartbeat", null, function (message) {
      callback.appMsgfunc(message);
    });
  }
}
/**
 * 初始化视频获取视频对象
 * @param {*} sip  //用户传过来的服务ip地址 http://{ip}:{port}
 * @param {*} token 
 * @param {*} videoArea //展示视频的容器模块
 * 使用该方法前提是videoArea等相关dom节点必须已加载完毕
 */


export const initVideo = function (token, videoArea, videoOpts_, sip) {
  //读取视频服务配置初始化视频
  let server_ = sip || server;
  return new Promise((resolve, reject) => {
    let url = server_ + '/scooper-video/conf/data?token=' + token;
    let param = {}; // $.getJSON(url,param,function (conf) {

    $.post(url, param, function (conf) {
      // 初始化视频播放方式
      // initplaVideoType();
      let janusUrl = conf['video.janus.url'];
      let videoOpts = {
        //初始化时的界面显示的分屏树
        windows: 4,
        //共有哪几种分屏
        windowsArr: [1, 2, 4, 9, 16],
        //总的窗口数
        windowsNum: 16,
        conf: {
          user: conf['video.username'],
          passwd: conf['video.password'],
          ip: conf['video.ip'],
          port: conf['video.port'],
          janusUrl: conf['video.janus.url'],
          token: token
        },
        extra: false,
        streamType: conf['video.stream'],
        openChangeWindowStrategy: conf['video.openChangeWindowStrategy'] === 'true',
        capImage: conf['video.cap.image'] === 'true',
        videoCapImagePath: conf['video.cap.image.path'],
        videoInfoInBottom: false
      };
      if (videoOpts_) Object.assign(videoOpts, videoOpts_);
      conf['video.poll.time'] && (videoOpts.pollInterval = conf['video.poll.time']);
      let videoController = new Video($(videoArea), videoOpts);
      resolve(videoController);
    }, 'json');
  });
};